import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'

export const ItemMasterPopup = (props) => {
    return (
        <ModalBasic
            id="itemMaster"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Item master - Raw material</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200'>
                    <div className='input-grp'>
                        <label>Sr no.</label>
                        <TextInput type='number'
                            id='srNo' name='srNo'
                            value={props.itemObject.srNo}
                            handleChange={(event) => props.handleChange(event, 'srNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item code</label>
                        <TextInput type='text'
                            id='itemCode' name='itemCode'
                            value={props.itemObject.itemCode}
                            handleChange={(event) => props.handleChange(event, 'itemCode')}
                            className={props.validState?.error?.itemCode !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item group</label>
                        <MultiSelectDropdown
                            drpIdentity="Select group"
                            options={props.itemObject.itemGroupList}
                            value={props.itemObject.itemGrpId ? props.itemObject.itemGroupList.find(x => x.value === props.itemObject.itemGrpId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "itemGrpId")
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.itemObject.types}
                            value={props.itemObject.itemType ? props.itemObject.types.find(x => x.label === props.itemObject.itemType) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "itemType")
                            }
                            className={props.validState?.error?.itemType !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item category</label>
                        <MultiSelectDropdown
                            drpIdentity="Select group"
                            options={props.itemObject.itemCategoryList}
                            value={props.itemObject.idItemCategory ? props.itemObject.itemCategoryList.find(x => x.value === props.itemObject.idItemCategory) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "idItemCategory")
                            }
                            className={props.validState?.error?.idItemCategory !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        <TextInput type='text'
                            id='itemName' name='itemName'
                            value={props.itemObject.itemName}
                            handleChange={(event) => props.handleChange(event, 'itemName')}
                            className={props.validState?.error?.itemName !== undefined ? "error" : ""}
                        />
                        {/* <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.itemObject.itemCategoryNameList}
                            value={props.itemObject.itemName ? props.itemObject.itemCategoryNameList.find(x => x.label === props.itemObject.itemName) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "itemName")
                            }
                            className={props.validState?.error?.itemName !== undefined ? "error" : ""}
                        /> */}
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Display name</label>
                        <TextInput type='text'
                            id='displayName' name='displayName'
                            value={props.itemObject.displayName}
                            handleChange={(event) => props.handleChange(event, 'displayName')}
                            className={props.validState?.error?.displayName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Short code</label>
                        <TextInput type='text'
                            id='shortCode' name='shortCode'
                            value={props.itemObject.shortCode}
                            handleChange={(event) => props.handleChange(event, 'shortCode')}
                            className={props.validState?.error?.shortCode !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item unit</label>
                        <MultiSelectDropdown
                            drpIdentity="Select unit"
                            options={props.itemObject.itemUnitList}
                            value={props.itemObject.idUnit ? props.itemObject.itemUnitList.find(x => x.value === props.itemObject.idUnit) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "idUnit")
                            }
                            className={props.validState?.error?.idUnit !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Search text</label>
                        <TextInput type='text'
                            id='searchText' name='searchText'
                            value={props.itemObject.searchText}
                            handleChange={(event) => props.handleChange(event, 'searchText')}
                            className={props.validState?.error?.searchText !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select material</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.itemObject.materialList}
                            value={props.itemObject.idMaterial ? props.itemObject.materialList.find(x => x.value === props.itemObject.idMaterial) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "idMaterial")
                            }
                            className={props.validState?.error?.idMaterial !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item description - Raw material</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>HSN code</label>
                        <TextInput type='text'
                            id='hsnCode' name='hsnCode'
                            value={props.itemObject.hsnCode}
                            handleChange={(event) => props.handleChange(event, 'hsnCode')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item size</label>
                        <MultiSelectDropdown
                            drpIdentity="Select size"
                            options={props.itemObject.itemSizeList}
                            value={props.itemObject.idProductSize ? props.itemObject.itemSizeList.find(x => x.value === props.itemObject.idProductSize) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "idProductSize")
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Opening stock</label>
                        <TextInput type='Number'
                            id='openingStock' name='openingStock'
                            value={props.itemObject.openingStock}
                            handleChange={(event) => props.handleChange(event, 'openingStock')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Opening stock date</label>
                        <TextInput type='date'
                            id='openingStockDate' name='openingStockDate'
                            value={props.itemObject.openingStockDate}
                            handleChange={(event) => props.handleChange(event, 'openingStockDate')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Curren stock</label>
                        <TextInput type='Number'
                            id='currentStock' name='currentStock'
                            value={props.itemObject.openingStock}
                            handleChange={(event) => props.handleChange(event, 'currentStock')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item weight</label>
                        <TextInput type='text'
                            id='itemWeight' name='itemWeight'
                            value={props.itemObject.itemWeight}
                            handleChange={(event) => props.handleChange(event, 'itemWeight')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Minimum level</label>
                        <TextInput type='text'
                            id='minLevel' name='minLevel'
                            value={props.itemObject.minLevel}
                            handleChange={(event) => props.handleChange(event, 'minLevel')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Maximum level</label>
                        <TextInput type='text'
                            id='maxLevel' name='maxLevel'
                            value={props.itemObject.maxLevel}
                            handleChange={(event) => props.handleChange(event, 'maxLevel')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Order quantity</label>
                        <TextInput type='number'
                            id='orderQty' name='orderQty'
                            value={props.itemObject.orderQty}
                            handleChange={(event) => props.handleChange(event, 'orderQty')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Locked quantity</label>
                        <TextInput type='number'
                            id='lockedQty' name='lockedQty'
                            value={props.itemObject.lockedQty}
                            handleChange={(event) => props.handleChange(event, 'lockedQty')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item rate</label>
                        <TextInput type='number'
                            id='itemRate' name='itemRate'
                            value={props.itemObject.itemRate}
                            handleChange={(event) => props.handleChange(event, 'itemRate')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Costing rate</label>
                        <TextInput type='number'
                            id='costingRate' name='costingRate'
                            value={props.itemObject.costingRate}
                            handleChange={(event) => props.handleChange(event, 'costingRate')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Purchase rate</label>
                        <TextInput type='number'
                            id='purchaseRate' name='purchaseRate'
                            value={props.itemObject.purchaseRate}
                            handleChange={(event) => props.handleChange(event, 'purchaseRate')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Jobwork rate</label>
                        <TextInput type='number'
                            id='jobWorkRate' name='jobWorkRate'
                            value={props.itemObject.jobWorkRate}
                            handleChange={(event) => props.handleChange(event, 'jobWorkRate')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Tax group</label>
                        <MultiSelectDropdown
                            drpIdentity="Tax group"
                            options={props.itemObject.taxStructureList}
                            value={props.itemObject.idTaxStructure ? props.itemObject.taxStructureList.find(x => x.value === props.itemObject.idTaxStructure) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "idTaxStructure")
                            }
                            className={props.validState?.error?.idTaxStructure !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rate on</label>
                        <MultiSelectDropdown
                            drpIdentity="Rate"
                            options={props.itemObject.rateOnList}
                            value={props.itemObject.rateOn ? props.itemObject.rateOnList.find(x => x.label === props.itemObject.rateOn) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(event, "rateOn")
                            }
                            className={props.validState?.error?.rateOn !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Drawing no.</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChange(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                        />
                    </div>
                    {/* <div className='input-grp relative'>
                        <form className="input-grp w-full">
                            <label
                                htmlFor="upload_Logo"
                            >
                                Drawing file
                            </label>
                            <input
                                className="!pr-[35px]"
                                id="drawing_file"
                                type="file"
                                onChange={(event) => props.onFileChange(event, 'DrawingFile')}
                            />
                        </form>
                        {props.itemObject.logoFileName ?
                            <button
                                className="w-[20px] h-[20px] flex absolute bottom-[15%] right-[3%]"
                                onClick={() =>
                                    props.getFiles(
                                        "File",
                                        props.itemObject.logoFileName
                                    )
                                }
                            >
                                <FontAwesomeIcon icon={faEye} className="text-[#e78e3c] " title="View file" />
                            </button>
                            :
                            null
                        }
                    </div> */}
                    <div className='input-grp relative'>
                        <form className="input-grp w-full">
                            <label
                                htmlFor="upload_DrawingFile"
                            >
                                Drawing file
                            </label>
                            <input
                                className="!pr-[35px]"
                                id="upload_DrawingFile"
                                type="file"
                                ref={props.drawingFileRef}
                                // onBlur={() => props.validateField("report")}
                                onChange={(event) => props.onFileChange(event, 'DrawingFile')}
                            />
                        </form>
                        {props.itemObject.drawingFile ?
                            <button
                                className="w-[20px] h-[20px] flex absolute bottom-[15%] right-[3%]"
                                onClick={() =>
                                    props.getFiles(
                                        "DrawingFile",
                                        props.itemObject.drawingFile
                                    )
                                }
                            >
                                <FontAwesomeIcon icon={faEye} className="text-[#e78e3c]" title="View file" />
                            </button>
                            :
                            null
                        }
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Location</label>
                        <TextInput type='text'
                            id='location' name='location'
                            value={props.itemObject.location}
                            handleChange={(event) => props.handleChange(event, 'location')}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label className='flex items-center gap-[5px]'>
                            <TextInput type='checkbox'
                                id='manage' name='manage'
                                value={props.itemObject.manage}
                                handleChange={(event) => props.handleChange(event, 'manage')}
                                className="w-[15px] h-[15px]"
                                checked={props.itemObject.manage}
                            />
                            Manage inventory for this item
                        </label>
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}